<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    cinematic_blur
                </mat-icon>
                <app-search-marquee #searchMarquee [searchRequestTypeEnum]="searchRequestTypeEnum"
                                    [searchRequestTileComponentTypeName]="searchRequestTileComponentTypeName"
                                    [disabled]="isSearchMarqueeDisabled">
                </app-search-marquee>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                <!--Enter search criteria to client activity-->
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <br />
                <!--<mat-tab-group *ngIf="searchResult.length > 0">
                    <mat-tab label="Results">
                        <br />-->
                        <table mat-table [dataSource]="searchResultDatasource" class="search-result mat-elevation-z8" matSort>
                            <ng-container matColumnDef="AvatarBlobPath">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let engagement" (click)="editItem(engagement.EngagementId)">
                                    <div class="circle-container-extra-small">
                                        <div class="half left">
                                            <app-image className="app-image-extra-small" srcPath="{{ engagement.ResourceAvatarBlobPath }}" isApiImage="true"></app-image>
                                        </div>
                                        <div class="half right">
                                            <app-image className="app-image-extra-small circle-container-extra-small-right-img" srcPath="{{ engagement.ProductionAvatarBlobPath }}" isApiImage="true"></app-image>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="ProductionName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Project </th>
                                <td mat-cell *matCellDef="let engagement" (click)="editItem(engagement.EngagementId)">
                                    {{ engagement.ProductionName }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="ResourceName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Client </th>
                                <td mat-cell *matCellDef="let engagement" (click)="editItem(engagement.EngagementId)">
                                    {{ engagement.ResourceName }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="RoleName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                                <td mat-cell *matCellDef="let engagement" (click)="editItem(engagement.EngagementId)">
                                    {{ engagement.ProductionRoleName }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="EngagementStatus">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                                <td mat-cell *matCellDef="let engagement" (click)="editItem(engagement.EngagementId)">
                                    {{ engagement.EngagementStatus }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let engagement">
                                    <button mat-button (click)="deleteItem(engagement.EngagementId, engagement.ProductionName)">
                                        <mat-icon class="material-symbols-outlined">
                                            delete_forever
                                        </mat-icon>
                                    </button>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    <!--</mat-tab>
                </mat-tab-group>-->
            </form>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

